import React from "react";
import { Link } from "react-router-dom";

const SetupInfoCard = ({ setupInfo = {} }) => {
  const steps = [
    {
      label: "Kullanıcılar",
      description: "Ekip ve yetkiler",
      icon: "icon-user-follow",
      path: "/user-add",
      completed: true,
    },
    {
      label: "Şubeler",
      description: "Servis noktaları",
      icon: "icon-pointer",
      path: "/branch-add",
      completed: setupInfo.branches > 0,
    },
    {
      label: "Durumlar",
      description: "İş akışı adımları",
      icon: "icon-info",
      path: "/statu-add",
      completed: setupInfo.status > 2,
    },
    {
      label: "Servis tipleri",
      description: "Hizmet kategorileri",
      icon: "icon-settings",
      path: "/operation-type-add",
      completed: setupInfo.types > 0,
    },
    {
      label: "İşletme",
      description: "Firma bilgileri",
      icon: "icon-home",
      path: "/settings/business",
      completed: Boolean(setupInfo.business),
    },
    {
      label: "Bildirimler",
      description: "İletişim tercihleri",
      icon: "icon-bell",
      path: "/settings/notification-prefers",
      completed: Boolean(setupInfo.notification),
    },
  ];

  const completedCount = steps.filter(step => step.completed).length;
  const progress = Math.round((completedCount / steps.length) * 100);

  return (
    <section className="dz-setup-strip" aria-labelledby="dashboard-setup-title">
      <div className="dz-setup-overview">
        <span className="dz-setup-mark"><i className="fa fa-magic" /></span>
        <div className="dz-setup-copy">
          <span>KURULUM MERKEZİ</span>
          <h2 id="dashboard-setup-title">İşletmenizi kullanıma hazırlayın</h2>
          <p>{completedCount}/{steps.length} adım tamamlandı · Eksik adımları buradan hızla tamamlayın.</p>
        </div>
        <div className="dz-setup-progress" aria-label={`Kurulum yüzde ${progress} tamamlandı`}>
          <div className="dz-setup-progress-copy"><strong>%{progress}</strong><span>Tamamlandı</span></div>
          <div className="dz-setup-progress-track"><span style={{ width: `${progress}%` }} /></div>
        </div>
      </div>

      <div className="dz-setup-steps">
        {steps.map(step => (
          <Link
            key={step.label}
            to={step.path}
            className={`dz-setup-step${step.completed ? " is-complete" : ""}`}
            title={`${step.label}: ${step.description}`}
          >
            <span className="dz-setup-step-icon"><i className={step.icon} /></span>
            <span className="dz-setup-step-copy"><strong>{step.label}</strong><small>{step.description}</small></span>
            <span className="dz-setup-step-state">
              <i className={step.completed ? "fa fa-check" : "fa fa-arrow-right"} />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default SetupInfoCard;
